import { MouseEventHandler, VFC, useState } from 'react'
import { Button, ButtonSize } from '@opallabs/lapidary'
import { useTextEditor } from '@opallabs/text-editor'
import { useEditorVisibility } from '../../hooks'
import * as styles from './styles'

type ReadMoreOverlayProps = {
  isFullScreen: boolean
}

export const ReadMoreOverlay: VFC<ReadMoreOverlayProps> = ({
  isFullScreen,
}) => {
  const { isContentOverflowed } = useTextEditor()
  const [isExpanded, setExpanded] = useState(false)
  const isVisible = useEditorVisibility({ blurDebounceDelay: 100 })

  const handleButtonClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation()
    setExpanded(!isExpanded)
  }

  return (
    <div
      data-testid="texteditor-read-more-overlay"
      css={styles.readMoreOverlay({
        isExpanded,
        isOverflowed: isContentOverflowed && !isFullScreen && !isVisible,
      })}
      className="read-more-overlay"
      onClick={() => setExpanded(true)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          setExpanded(true)
        }
      }}
      role="button"
      tabIndex={0}
    >
      <Button
        aria-label={
          (isExpanded ? 'Read more' : 'Read less') + ' text in this section'
        }
        buttonText={isExpanded ? 'Read Less' : 'Read More'}
        className={`read-more-button-${isExpanded ? 'expanded' : 'collapsed'}`}
        data-testid="texteditor-read-more-toggle"
        name="read-more"
        onClick={handleButtonClick}
        size={ButtonSize.Small}
        variant="secondary"
      />
    </div>
  )
}
